export enum ChatBotEventType {
  CHAT_BOT_CLOSE_EVENT = 'chat_bot_close_event',
  CHAT_BOT_ONBOARDING_COMPLETE = 'chat_bot_onboarding_complete',
  COPILOT_TRACKING_EVENT = 'copilot_tracking_event',
  CHAT_BOT_OPEN_EVENT = 'startChatBot',
  COPILOT_OUTCOME_EVENT = 'copilot_outcome_event',
  CHAT_BOT_START_PRACTICE_EVENT = 'startFeedbackPractice'
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/chat-bot-event.enum.ts